import { createRef, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { createPortal } from "react-dom";

const YearEditor = ({ row, column, onRowChange }) => {
  const [value, setValue] = useState(null);
  let ref = createRef();

  useEffect(() => {
    if (row[column.key]) {
      setValue(new Date(row[column.key], 1, 1));
    }
  }, [column.key, row]);

  const handleChangeYear = (date) => {
    setValue(date.getFullYear());
    onRowChange({ ...row, [column.key]: date.getFullYear() });
  };

  useEffect(() => {
    ref.setFocus();
  }, [ref]);

  return (
    <DatePicker
      popperContainer={({ children }) => createPortal(children, document.body)}
      ref={(input) => (ref = input)}
      selected={value}
      onChange={handleChangeYear}
      showYearPicker
      dateFormat="yyyy"
      yearItemNumber={10}
    />
  );
};

export default YearEditor;
